import PropTypes from 'prop-types';
import React from 'react';

import SuccessIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/ReportProblem';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
   const succesColor = theme.succes ? theme.succes.light : 'green';
   const warningColor = theme.succes ? theme.succes.light : 'orange';
   const errorColor = theme.succes ? theme.succes.light : 'red';
   return {
      divider: {
         borderTop: '1px solid #D3D3D3',
      },
      actions: {
         padding: '12px 24px',
      },
      succes: {
         color: succesColor
      },
      warning: {
         color: warningColor
      },
      error: {
         color: errorColor
      },
      dialogRoot: {
         '& .MuiDialog-paper': {
            borderRadius: '10px'
         }
      },
      title: {
         wordBreak: 'break-word'
      },
   };
});

function ConfirmDialog({
   titulo,
   children,
   open,
   setOpen,
   onConfirm,
   variant,
   disableTypography,
   onCancel,
   buttonSize,
   cancelStyle,
   confirmStyle,
   cancelVariant,
   confirmVariant,
   cancelText,
   confirmText,
   confirmColor,
   esOpcionUnica,
   confirmGrid,
   cancelGrid,
   ...other
}) {
   const { classes } = useStyles();
   
   function tituloMostrar() {
      if (!titulo) {
         switch (variant) {
            case 'success': return 'Éxito';
            case 'warning': return 'Advertencia';
            case 'error': return 'Error';
            default: return '';
         }
      }
      return titulo;
   }

   function closeDialog() {
      onCancel();
      setOpen(false);
   }
   const confirmButtonColor = confirmColor ? confirmColor : 'error';

   return (
      <Dialog   maxWidth="sm" open={open} onClose={closeDialog} aria-labelledby="confirm-dialog" fullWidth  className={classes.dialogRoot} {...other}>
         <DialogTitle>
            <Grid container alignItems="center">
               <Grid item xs={1}>
                  {variant === 'success' && <SuccessIcon color="success" />}
                  {variant === 'warning' && <WarningIcon color="warning" />}
                  {variant === 'error' && <ErrorIcon color="error" />}
               </Grid>
               <Grid item xs={11}>
                  <Typography component="h2" variant="h6"   className={classes.title}>{tituloMostrar()}</Typography>
               </Grid>
            </Grid>
         </DialogTitle>
         {children && (
            <DialogContent>
               {disableTypography ? children : <Typography variant="body1">{children}</Typography>}
            </DialogContent>
         )}
         <DialogActions className={classes.actions}>
            <Grid container justifyContent={esOpcionUnica ? "center" : "space-between"}>
               {!esOpcionUnica && (
                  <Grid item xs={cancelGrid} container justifyContent="flex-start">
                     <Button size={buttonSize} variant={cancelVariant} onClick={closeDialog} style={cancelStyle}>
                        {cancelText}
                     </Button>
                  </Grid>
               )}
               <Grid item xs={esOpcionUnica ? 6 : confirmGrid} container justifyContent={esOpcionUnica ? "center" : "flex-end"}>
                  <Button
                     size={buttonSize}
                     variant={confirmVariant}
                     onClick={() => {
                        onConfirm();
                        setOpen(false);
                     }}
                     color={confirmButtonColor}
                     style={confirmStyle}
                  >
                     {confirmText}
                  </Button>
               </Grid>
            </Grid>
         </DialogActions>
      </Dialog>
   );
}

ConfirmDialog.propTypes = {
   open: PropTypes.bool.isRequired,
   setOpen: PropTypes.func.isRequired,
   titulo: PropTypes.string,
   onConfirm: PropTypes.func,
   onCancel: PropTypes.func,
   confirmGrid: PropTypes.number,
   cancelGrid: PropTypes.number,
   variant: PropTypes.oneOf(['default', 'success', 'warning', 'error']),
   buttonSize: PropTypes.oneOf(['small', 'medium', 'large']),
   cancelVariant: PropTypes.oneOf(['text', 'outlined', 'contained']),
   confirmVariant: PropTypes.oneOf(['text', 'outlined', 'contained']),
   cancelText: PropTypes.string,
   confirmText: PropTypes.string,
   confirmColor: PropTypes.oneOf(['success', 'warning', 'error', 'primary', 'secondary']),
   esOpcionUnica: PropTypes.bool,
};

ConfirmDialog.defaultProps = {
   variant: 'default',
   buttonSize: 'medium',
   confirmVariant: 'contained',
   cancelVariant: 'outlined',
   cancelText: 'No',
   confirmText: 'Sí',
   confirmGrid: 3,
   cancelGrid: 3,
   confirmColor: 'error',
   esOpcionUnica: false,
   onConfirm: () => {},
   onCancel: () => {},
};

export default ConfirmDialog;
